import React from 'react';
import styled from 'styled-components';
import { Col, Row } from 'react-styled-flexboxgrid';
import Page from '../components/Page';

// STYLES
const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  margin-bottom: 1.2rem;
  border: 2px solid black;
  cursor: pointer;

  @media only screen and (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}em) {
    width: 60%;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &:nth-child(1) {
    img {
      bottom: -28px;
      left: 10%;
    }

    .client {
      text-align: right;
    }
  }

  &:nth-child(2) {
    margin-left: auto;

    img {
      bottom: -23px;
      right: 10%;
    }
  }

  &:nth-child(3) {
    margin-left: auto;
    margin-right: auto;

    img {
      bottom: 23px;
      right: -42px;
    }
  }

  &:nth-child(4) {
    margin-left: auto;

    @media only screen and (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}em) {
      margin-right: 10%;
    }

    img {
      bottom: 23px;
      right: -42px;
    }
  }
`;

const ListLink = styled.a`
  text-decoration: none;
  font-weight: bold;
  transition: all 0.2s;
  display: inline-block;
  line-height: 1.2;
  position: relative;
  padding: 15px;
  z-index: 10;

  &:hover {
    color: ${props => props.theme.color.secondary};
    text-decoration: none;

    img {
      opacity: 1;
    }
  }
`;

const Icon = styled.img`
  width: 70px;
  position: absolute;
  opacity: 0;
  transition: all 0.2s;
  display: none;

  @media only screen and (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}em) {
    display: block;
  }
`;

const Client = styled.p`
  text-align: left;
  margin-top: 15px;
`;


// COMPONENT
const StimmenUeberMich = props => {
  
  const { data } = props;

  return (
    <Page title="Stimmen über mich">
      <List>
        { data.references.map(ref => (
          <ListItem key={ ref.value.file } >
            <ListLink href={ ref.value.link } target="_blank" rel="noopener noreferrer">
                
                <div dangerouslySetInnerHTML={{ __html: ref.value.text }}></div>
                <Client className="client">{ ref.value.client }</Client>
                <Icon src={ process.env.REACT_APP_ROOT + '/' + ref.value.icon } alt="" />

            </ListLink>
          </ListItem>
        )) }
      </List>
    </Page>
  );
};

export default StimmenUeberMich;